import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonCircleList from '../../../common-components/common-circle-list';

let list = {
    colorNumber: '#7927E0',
    list: [
        'Аудит сайта и устранение ошибок',
        'Внедрение технических решений для регионального продвижения',
        'Расширение структуры сайта',
    ],
};

const TasksSeo = () => {
    return (
        <div className="seo-tasks">
            <ScrollAnimation
                animateIn="fadeInUp"
                offset={100}
                animateOnce={true}
                duration={1}
                className="upgreat-tasks__content"
            >
                <FullWrapper>
                    <div className="seo-tasks__content">
                        <div className="seo-tasks__block-img">
                            <img
                                className="seo-tasks__img"
                                src="/images/pic/seo-fintech/seo-tasks.png"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <div className="seo-tasks__block-text">
                            <div className="seo-tasks__text">
                                Команда Вебпрактик занимается SEO нескольких крупных российских
                                банков из ТОП 50 (по версии Банки.ру). Наша экспертиза позволила нам
                                выработать общую стратегию при работе с банками, которая включает в
                                себя следующие этапы:
                            </div>
                            <div className="seo-tasks__list">
                                <CommonCircleList CommonCircleList={list} />
                            </div>
                            <div className="seo-tasks__text-bold">
                                Каждый этап представляет собой комплекс работ, обязательно
                                включающий в себе анализ конкурентов.
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        </div>
    );
};

export default TasksSeo;
